import { fetchSlaSettings } from "api";
import { useEffect, useState } from "react";
import { readCachedEnabled, writeCachedEnabled } from "./SlaLiveKpiChips";

/**
 * true solo quando lo SLA dell'organizzazione e' attivo
 * (`GET .../settings` -> `enabled`). Stessa cache del Monitor vivo, cosi'
 * Statistiche e Avvio processo non mostrano superfici SLA a un'organizzazione
 * che le ha disattivate.
 *
 * Lettura fallita (403, rete, 404): si resta sul valore in cache, o `false`
 * se non c'e' ancora un esito noto — meglio nascondere che mostrare SLA inerte.
 *
 * La rotta e' admin-only: per un non-admin non si chiama e il valore e' `false`.
 * Le superfici che la usano (sezione SLA di Avvio processo, vista SLA di
 * Statistiche) leggono a loro volta rotte admin-only, quindi per il non-admin
 * restano nascoste invece di mostrare un "forbidden". Lo SLA del non-admin vive
 * nelle Attivita', dove `SlaActivitiesProvider` lo deriva dalle istanze.
 */
const useSlaOrganizationEnabled = (
  idorganization: number | null | undefined,
  administrator: boolean,
): boolean => {
  const [enabled, setEnabled] = useState<boolean>(() =>
    administrator && idorganization ? readCachedEnabled(idorganization) : false,
  );

  useEffect(() => {
    if (!idorganization || !administrator) {
      setEnabled(false);
      return;
    }
    setEnabled(readCachedEnabled(idorganization));
    let cancelled = false;
    (async () => {
      try {
        const settings = await fetchSlaSettings(idorganization);
        if (cancelled) return;
        const isEnabled = settings?.enabled === true;
        writeCachedEnabled(idorganization, isEnabled);
        setEnabled(isEnabled);
      } catch {
        if (cancelled) return;
        const cached = readCachedEnabled(idorganization);
        setEnabled(cached);
        if (!cached) writeCachedEnabled(idorganization, false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [idorganization, administrator]);

  return enabled;
};

export default useSlaOrganizationEnabled;
